<template>
  <div class="gen-sign-in" :class="{ 'is-compact-upload': compactUpload, 'is-upload-only': uploadOnly, 'is-records-only': recordsOnly }">
    <!-- 上传区域 -->
    <div v-if="!recordsOnly" class="gen-sign-upload-card">
      <div class="gen-sign-upload-header">
        <div class="gen-sign-upload-title">
          <i class="el-icon-upload2"></i>
          <span>上传签到表原始数据</span>
        </div>
        <span class="gen-sign-tip">支持 JPG / PNG / BMP 格式，最多 10 张，选择后自动逐张上传识别</span>
      </div>
      <div class="gen-sign-upload-body">
        <el-upload
          ref="uploadRef"
          class="gen-sign-upload"
          drag
          action="#"
          :auto-upload="false"
          :limit="10"
          multiple
          accept=".jpg,.jpeg,.png,.bmp"
          :file-list="fileList"
          :on-change="handleFileChange"
          :on-exceed="handleFileExceed"
          :before-upload="() => false"
          :show-file-list="false"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将图片拖到此处，或<em>点击选择签到表图片</em></div>
        </el-upload>
        <span v-if="uploadLoading" class="gen-sign-upload-warn">
          <i class="el-icon-warning"></i> 请等待上传结束后再关闭弹框，否则会导致上传失败
        </span>
      </div>
      <div class="gen-sign-upload-status-card">
        <div class="gen-sign-upload-status-card__main">
          <span>已识别 {{ records.length }} 张签到表</span>
          <span v-if="uploadLoading" class="gen-sign-upload-progress">
            <i class="el-icon-loading"></i> 正在上传
            <span class="gen-sign-upload-progress-num">{{ successCount }}/{{ totalUploadCount }}</span>
          </span>
        </div>
        <div class="gen-sign-upload-status-card__sub">
          <template v-if="uploadLoading">
            <span class="gen-sign-upload-pill gen-sign-upload-pill--uploading" v-if="uploadingCount">上传中 {{ uploadingCount }} 张</span>
            <span class="gen-sign-upload-pill gen-sign-upload-pill--pending" v-if="pendingCount">等待上传 {{ pendingCount }} 张</span>
            <span class="gen-sign-upload-pill gen-sign-upload-pill--retrying" v-if="retryingCount">重试中 {{ retryingCount }} 张</span>
          </template>
          <span v-else-if="failedUploadCount">失败 {{ failedUploadCount }} 张，请重新上传</span>
          <span v-else>{{ signUploaded ? '已生成签到整合数据，可继续上传考勤表' : '上传成功后可点击签到表整合' }}</span>
        </div>
      </div>
      <!-- 图片预览网格 -->
      <div v-if="uploadItems.length" class="gen-sign-preview-grid">
        <div v-for="(item, idx) in uploadItems" :key="idx" class="gen-sign-preview-item">
          <div class="gen-sign-preview-thumb" @click="handlePreviewImage(item.url)">
            <img :src="item.url" alt="" />
            <div v-if="item.status === 'uploading'" class="gen-sign-preview-loading"><i class="el-icon-loading"></i></div>
            <div v-else-if="item.status === 'retrying'" class="gen-sign-preview-loading gen-sign-preview-loading--retry">
              <i class="el-icon-refresh-right"></i>
            </div>
            <div v-else-if="item.status === 'success'" class="gen-sign-preview-badge gen-sign-preview-badge--success"><i class="el-icon-check"></i></div>
            <div v-else-if="item.status === 'fail'" class="gen-sign-preview-badge gen-sign-preview-badge--fail"><i class="el-icon-close"></i></div>
            <i
              v-if="item.status === 'pending'"
              class="el-icon-circle-close gen-sign-preview-del"
              @click.stop="handleRemoveUploadItem(idx)"
            ></i>
          </div>
          <div class="gen-sign-preview-name">{{ item.name }}</div>
          <div class="gen-sign-preview-status" :class="'preview-status--' + item.status">
            <template v-if="item.status === 'pending'">等待上传</template>
            <template v-else-if="item.status === 'uploading'">上传中...</template>
            <template v-else-if="item.status === 'retrying'">重试中({{ item.retryCount }}/2)</template>
            <template v-else-if="item.status === 'success'">上传成功</template>
            <template v-else-if="item.status === 'fail'">上传失败</template>
          </div>
        </div>
      </div>
    </div>

    <!-- 识别记录列表 -->
    <div v-if="!uploadOnly" v-loading="loading" class="gen-sign-records-card">
      <div class="gen-sign-records-header">
        <div class="gen-sign-records-title">
          <i class="el-icon-tickets"></i>
          <span>识别记录(支持修改表格数据)</span>
          <span v-if="records.length" class="gen-sign-records-count">{{ records.length }}</span>
        </div>
        <el-button v-if="false" type="primary" size="small" icon="el-icon-connection" :loading="mergeLoading" @click="handleMergeSign">签到表整合</el-button>
      </div>
      <div class="gen-sign-records-body">
        <div v-if="records.length === 0" class="gen-sign-empty">
          <div class="gen-sign-empty-icon"><i class="el-icon-document-checked"></i></div>
          <div class="gen-sign-empty-text">暂无识别记录</div>
          <div class="gen-sign-empty-hint">上传签到表图片后，识别记录将显示在这里</div>
        </div>
        <div v-for="item in records" :key="item.rrmusoId" class="gen-sign-record-item" @click="handleViewDetail(item)">
          <div class="gen-sign-record-icon"><i class="el-icon-document-checked"></i></div>
          <div class="gen-sign-record-info">
            <span class="gen-sign-record-name">识别记录 #{{ item.rrmusoId }}</span>
            <span class="gen-sign-record-meta">
              {{ item.createusername || '-' }} · {{ item.createtime || '-' }}
              <span class="gen-sign-record-status" :class="item.ocrStatus === 1 ? 'is-success' : 'is-fail'">
                {{ item.ocrStatus === 1 ? '识别成功' : '识别失败' }}
              </span>
            </span>
          </div>
          <el-button type="text" size="small" class="gen-sign-record-del" @click.stop="handleDeleteRecord(item)"><i class="el-icon-delete"></i></el-button>
          <el-button type="text" size="small" class="gen-sign-record-action">查看结果 <i class="el-icon-arrow-right"></i></el-button>
        </div>
      </div>
    </div>

    <!-- 签到表识别结果弹窗 -->
    <el-dialog
      v-dialog-drag-resize
      :visible.sync="detailVisible"
      width="80%"
      title="签到表识别结果"
      :close-on-click-modal="false"
      append-to-body
      custom-class="sign-detail-dialog"
    >
      <div v-if="detailData" class="sign-detail-content">
        <div class="sign-detail-meta">
          <div class="sign-detail-meta-row" v-for="(row, ri) in metaRows" :key="ri">
            <div class="sign-detail-meta-cell sign-detail-meta-cell--label">{{ row[0].label }}</div>
            <div class="sign-detail-meta-cell sign-detail-meta-cell--value">{{ row[0].value }}</div>
            <div v-if="row[1]" class="sign-detail-meta-cell sign-detail-meta-cell--label">{{ row[1].label }}</div>
            <div v-if="row[1]" class="sign-detail-meta-cell sign-detail-meta-cell--value">{{ row[1].value }}</div>
          </div>
        </div>

        <!-- 表格数据 -->
        <div class="sign-detail-section">
          <i class="el-icon-s-grid"></i>
          <span>签到表数据</span>
        </div>
        <div class="sign-detail-actions">
          <template v-if="!isEditing">
            <el-button size="small" icon="el-icon-edit" @click="handleStartEdit">编辑</el-button>
            <el-button type="primary" size="small" icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出 Excel</el-button>
          </template>
          <template v-else>
            <el-button size="small" @click="handleCancelEdit">取消</el-button>
            <el-button type="primary" size="small" :loading="editLoading" @click="handleConfirmEdit">确定</el-button>
          </template>
        </div>
        <div v-if="tableColumns.length && tableRows.length" class="sign-detail-table-wrap">
          <el-table
            :data="isEditing ? editableRows : tableRows"
            border
            stripe
            size="small"
            max-height="420"
            :class="{ 'is-cell-editing': isEditing }"
          >
            <el-table-column
              v-for="(col, ci) in columnConfigs"
              :key="col.prop"
              :prop="col.prop"
              :width="col.width"
              :min-width="col.minWidth"
              :align="col.align"
              header-align="center"
              :show-overflow-tooltip="!isEditing"
            >
              <template #header>
                <!-- 编辑模式：表头可点击编辑 -->
                <template v-if="isEditing">
                  <div
                    v-if="editingHeader !== null && editingHeader === ci"
                    class="sign-header-editing"
                  >
                    <el-input
                      v-model="editableHeadersObj[ci]"
                      size="mini"
                      class="sign-cell-input"
                      @blur="editingHeader = null"
                      @keydown.enter.native="editingHeader = null"
                    />
                  </div>
                  <div
                    v-else
                    class="sign-header-text"
                    @click="editingHeader = ci"
                  >{{ editableHeadersObj[ci] || '' }}</div>
                </template>
                <!-- 非编辑模式：静态展示 -->
                <span v-else>{{ editableHeaders[ci] || col.label }}</span>
              </template>
              <template #default="{ row, $index }">
                <template v-if="isEditing">
                  <div
                    v-if="editingCell && editingCell.rowIdx === $index && editingCell.colIdx === ci"
                    class="sign-cell-editing"
                  >
                    <el-input
                      v-model="editableRows[$index][col.prop]"
                      size="mini"
                      class="sign-cell-input"
                      @blur="editingCell = null"
                      @keydown.enter.native="editingCell = null"
                    />
                  </div>
                  <div
                    v-else
                    class="sign-cell-text"
                    @click="startCellEdit($index, ci)"
                  >{{ row[col.prop] || '' }}</div>
                </template>
                <span v-else>{{ row[col.prop] || '' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="gen-sign-empty sign-detail-empty">当前识别结果未解析出表格数据</div>

        <!-- 原始文本 -->
        <div class="sign-detail-section">
          <i class="el-icon-document"></i>
          <span>原始识别文本</span>
        </div>
        <div class="sign-detail-raw-text">{{ displayText }}</div>
      </div>
      <template #footer>
        <el-button size="small" @click="handleCloseDetail">关 闭</el-button>
      </template>
    </el-dialog>

    <!-- 签到表整合数据表格 -->
    <div v-if="!uploadOnly && !hideMergeTable" v-loading="mergeTableLoading" class="gen-sign-merge-card">
      <div class="gen-sign-merge-header">
        <div class="gen-sign-merge-title">
          <i class="el-icon-connection"></i>
          <span>签到表整合数据</span>
          <span v-if="mergeTableRows.length" class="gen-sign-merge-count">{{ mergeTableRows.length }} 条</span>
        </div>
        <div v-if="mergeRecord" class="gen-sign-merge-actions">
          <span class="gen-sign-merge-meta">{{ mergeRecord.createusername || '-' }} · {{ mergeRecord.createtime || '-' }}</span>
          <el-button type="success" size="small" icon="el-icon-document" :loading="mergeExportLoading" @click="handleMergeExport">使用模板导出</el-button>
        </div>
      </div>
      <div class="gen-sign-merge-body">
        <div v-if="!mergeTableLoading && mergeTableRows.length === 0" class="gen-sign-empty">
          <div class="gen-sign-empty-icon"><i class="el-icon-connection"></i></div>
          <div class="gen-sign-empty-text">暂无整合数据</div>
          <div class="gen-sign-empty-hint">点击上方"签到表整合"按钮，将所有签到表识别记录整合为一张表</div>
        </div>
        <div v-if="mergeTableRows.length" class="gen-sign-merge-table-wrap">
          <el-table :data="mergeTableRows" border stripe size="small" max-height="460" cell-class-name="sign-merge-cell-center">
            <el-table-column
              v-for="(col, ci) in mergeColumnConfigs"
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              :width="col.width"
              :min-width="col.minWidth"
              align="center"
              header-align="center"
              show-overflow-tooltip
            />
          </el-table>
        </div>
      </div>
    </div>

    <!-- 大图预览 -->
    <el-dialog v-dialog-drag-resize :visible.sync="previewVisible" title="图片预览" width="auto" append-to-body custom-class="preview-image-dialog">
      <img :src="previewImageUrl" alt="" style="max-width:100%;max-height:70vh;display:block;margin:0 auto;" />
    </el-dialog>
  </div>
</template>

<script>
import {
  getRtReportModelUserSignOcrList,
  getRtReportModelUserSignOcrDetails,
  addRtReportModelUserSignOcr,
  exportRtReportModelUserSignOcr,
  updateRtReportModelUserSignOcr,
  deleteRtReportModelUserSignOcr,
  updateRtReportModelUserSignMergeOnlySign,
  getRtReportModelUserSignMergeList,
  exportRtReportModelUserSignMergeSignExam,
  exportRtReportModelUserSignMergeSignExamUseModel
} from '@/api/api'

export default {
  name: 'ReportGenSignIn',
  props: {
    rrmaId: { type: [Number, String], default: null },
    compactUpload: { type: Boolean, default: false },
    uploadOnly: { type: Boolean, default: false },
    recordsOnly: { type: Boolean, default: false },
    hideMergeTable: { type: Boolean, default: false },
    mergeState: { type: Object, default: null }
  },
  data () {
    return {
      loading: false,
      uploadLoading: false,
      exportLoading: false,
      mergeLoading: false,
      mergeTableLoading: false,
      mergeExportLoading: false,
      records: [],
      fileList: [],
      // 批量上传：每张图的状态列表
      uploadItems: [],
      uploadTimer: null,
      // 大图预览
      previewVisible: false,
      previewImageUrl: '',
      detailVisible: false,
      detailData: null,
      editableHeaders: [],
      editableHeadersObj: {},
      isEditing: false,
      editLoading: false,
      editableRows: [],
      editingCell: null,
      editingHeader: null,
      // 整合数据
      mergeRecord: null,
      mergeTableColumns: [],
      mergeTableRows: [],
      mergeColumnConfigs: []
    }
  },
  computed: {
    failedUploadCount () {
      return this.uploadItems.filter(item => item.status === 'fail').length
    },
    uploadingCount () {
      return this.uploadItems.filter(item => item.status === 'uploading').length
    },
    pendingCount () {
      return this.uploadItems.filter(item => item.status === 'pending').length
    },
    retryingCount () {
      return this.uploadItems.filter(item => item.status === 'retrying').length
    },
    successCount () {
      return this.uploadItems.filter(item => item.status === 'success').length
    },
    totalUploadCount () {
      return this.uploadItems.length
    },
    signUploaded () {
      return !!(this.mergeState && this.mergeState.signAddExam)
    },
    // 识别结果元信息
    metaRows () {
      if (!this.detailData) return []
      return [
        [
          { label: '识别记录', value: '#' + (this.detailData.rrmusoId || '-') },
          { label: '识别人', value: this.detailData.createusername || '-' }
        ],
        [
          { label: '识别时间', value: this.detailData.createtime || '-' },
          { label: '数据行数', value: this.tableRows.length || 0 }
        ]
      ]
    },
    // 原始识别文本
    displayText () {
      if (!this.detailData) return '-'
      return this.detailData.ocrText || '-'
    },
    // 解析 ocrTextUser JSON
    ocrJsonData () {
      if (!this.detailData || !this.detailData.ocrTextUser) return null
      try { return JSON.parse(this.detailData.ocrTextUser) } catch { return null }
    },
    tableColumns () {
      const data = this.ocrJsonData
      if (!data || !data.headerMap) return []
      return data.headerMap.map(h => h[0] || '').filter(h => h)
    },
    tableRows () {
      const data = this.ocrJsonData
      if (!data || !data.rowMapList || !data.headerMap) return []
      const indices = data.headerMap.map((h, i) => (h[0] && h[0].trim()) ? i : -1).filter(i => i >= 0)
      if (!indices.length) return []
      return data.rowMapList.map(row => {
        const obj = {}
        indices.forEach((colIdx, i) => { obj['col_' + i] = row[colIdx] || '' })
        return obj
      }).filter(r => Object.values(r).some(v => v !== ''))
    },
    // 根据表头字数动态计算列宽（中文约14px/字，加左右内边距与缓冲）
    columnConfigs () {
      return this.tableColumns.map((col, i) => {
        const text = String(col || '').trim()
        // 计算字符宽度：中文算全角，英文/数字算半角
        let charWidth = 0
        for (const ch of text) {
          charWidth += /[一-鿿]/.test(ch) ? 14 : 8
        }
        // minWidth = 字符宽度 + 左右padding(32) + 边框缓冲(16)，最低80
        const minWidth = Math.max(80, charWidth + 48)
        return { prop: 'col_' + i, label: col, minWidth, align: 'center' }
      })
    }
  },
  watch: {
    rrmaId: {
      handler (val) {
        if (!val) return
        if (!this.uploadOnly) this.fetchList()
        if (!this.hideMergeTable) this.fetchMergeData()
      },
      immediate: true
    }
  },
  methods: {
    // 初始化可编辑表头（数组用于展示，对象用于编辑输入绑定）
    initEditableHeaders () {
      try {
        const data = this.detailData && this.detailData.ocrTextUser ? JSON.parse(this.detailData.ocrTextUser) : null
        this.editableHeaders = (data && data.headerMap)
          ? data.headerMap.map(h => h[0] || '').filter(h => h)
          : []
      } catch {
        this.editableHeaders = []
      }
      const obj = {}
      this.editableHeaders.forEach((h, i) => { obj[i] = h })
      this.editableHeadersObj = obj
    },

    // 开启编辑
    handleStartEdit () {
      // 深拷贝当前表格数据用于编辑
      this.editableRows = JSON.parse(JSON.stringify(this.tableRows))
      // 初始化可编辑表头对象
      const obj = {}
      this.editableHeaders.forEach((h, i) => { obj[i] = h })
      this.editableHeadersObj = obj
      this.editingCell = null
      this.isEditing = true
    },
    // 取消编辑：恢复原始表头
    handleCancelEdit () {
      this.editableRows = []
      this.editingCell = null
      this.editingHeader = null
      this.initEditableHeaders()
      this.isEditing = false
    },
    // 确认编辑：将编辑对象的值同步到数组并提交接口
    async handleConfirmEdit () {
      if (!this.detailData || !this.detailData.rrmusoId) return
      this.editLoading = true
      try {
        const newHeaders = Object.keys(this.editableHeadersObj)
          .sort((a, b) => a - b)
          .map(k => this.editableHeadersObj[k])
        // 将编辑后的表格数据转换为接口格式
        const newRowMapList = this.editableRows.map(row =>
          newHeaders.map((_, i) => row['col_' + i] || '')
        )
        const ocrTextUser = JSON.stringify({
          headerMap: newHeaders.map(h => [h]),
          rowMapList: newRowMapList
        })
        await updateRtReportModelUserSignOcr({
          rrmusoId: this.detailData.rrmusoId,
          ocrTextUser
        })
        this.editableHeaders = newHeaders
        this.detailData.ocrTextUser = ocrTextUser
        this.editingCell = null
        this.editingHeader = null
        this.isEditing = false
        this.$message.success('修改成功')
        // 编辑识别记录后刷新整合数据
        this.fetchMergeData()
        this.$emit('merge-updated')
      } catch (e) {
        this.$message.error('修改失败，请稍后重试')
      } finally {
        this.editLoading = false
      }
    },
    // 关闭详情弹框
    handleCloseDetail () {
      this.isEditing = false
      this.editingCell = null
      this.editingHeader = null
      this.editableRows = []
      this.detailVisible = false
    },
    // 点击单元格进入编辑状态
    startCellEdit (rowIdx, colIdx) {
      this.editingCell = { rowIdx, colIdx }
      this.$nextTick(() => {
        const input = this.$el.querySelector('.sign-cell-editing .el-input__inner')
        if (input) input.focus()
      })
    },

    // 加载识别记录列表
    async fetchList () {
      if (!this.rrmaId) return
      this.loading = true
      try {
        const res = await getRtReportModelUserSignOcrList({ rrmaId: this.rrmaId })
        this.records = Array.isArray(res.data) ? res.data : []
      } catch (e) {
        this.records = []
      } finally {
        this.loading = false
      }
    },

    // 删除识别记录
    async handleDeleteRecord (item) {
      try {
        await this.$confirm('确认删除该识别记录？删除后不可恢复。', '删除确认', { type: 'warning' })
        await deleteRtReportModelUserSignOcr({ rrmusoId: item.rrmusoId })
        this.$message.success('识别记录已删除')
        this.fetchList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败，请稍后重试')
        }
      }
    },

    // 收集文件到预览队列，防抖后开始逐张上传
    handleFileChange (file) {
      if (!file || !file.raw) return
      const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      if (!['.jpg', '.jpeg', '.png', '.bmp'].includes(ext)) {
        this.$message.warning(`文件 "${file.name}" 格式不支持，仅支持 JPG、PNG、BMP`)
        this.$nextTick(() => {
          if (this.$refs.uploadRef) {
            const idx = this.$refs.uploadRef.uploadFiles.findIndex(f => f.uid === file.uid)
            if (idx > -1) this.$refs.uploadRef.uploadFiles.splice(idx, 1)
          }
        })
        return
      }
      this.uploadItems.push({
        uid: file.uid,
        name: file.name,
        raw: file.raw,
        url: URL.createObjectURL(file.raw),
        status: 'pending',
        retryCount: 0
      })
      clearTimeout(this.uploadTimer)
      this.uploadTimer = setTimeout(() => { this.startBatchUpload() }, 300)
    },
    // 上传单张签到表（含失败自动重试）
    // 签到表需后端做 OCR 识别，调用第三方服务偶发超时，因此失败时按次数自动重试。
    async uploadSingleItem (item) {
      const maxRetry = 2
      for (let attempt = 0; attempt <= maxRetry; attempt++) {
        try {
          await addRtReportModelUserSignOcr({ rrmaId: this.rrmaId, file: item.raw })
          item.status = 'success'
          return
        } catch (e) {
          // 还有重试机会：标为重试中并等待后再来；否则判定为最终失败
          if (attempt < maxRetry) {
            item.status = 'retrying'
            item.retryCount = attempt + 1
            await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1)))
          } else {
            item.status = 'fail'
          }
        }
      }
    },

    // 限并发上传（默认同时 2 张），避免一次性把所有图片打到后端 OCR 导致集体超时
    async startBatchUpload () {
      const pending = this.uploadItems.filter(f => f.status === 'pending')
      if (!pending.length) return
      if (!this.rrmaId) {
        this.$message.warning('未获取到当前申请记录')
        this.uploadItems = []
        this.clearUploadRef()
        return
      }
      this.uploadLoading = true
      this.$emit('busy-change', true)

      // 并发数 2：用游标队列控制，每个任务完成后再从队列里取下一张
      // 优化：队列过程中不再逐张刷新列表（避免 N 张图片触发 N 次 OCR list 调用），
      // 全部队列完成后统一刷新一次列表 + 触发一次 merge-updated。
      const queue = pending.slice()
      let anySuccess = false
      const worker = async () => {
        while (queue.length) {
          const item = queue.shift()
          if (!item) break
          item.status = 'uploading'
          await this.uploadSingleItem(item)
          if (item.status === 'success') anySuccess = true
        }
      }
      const concurrency = 2
      await Promise.all(Array.from({ length: Math.min(concurrency, pending.length) }, () => worker()))

      // 全部完成后：有任意一张成功，统一刷新一次列表 + 整合数据
      if (anySuccess) {
        await this.fetchList()
        this.fetchMergeData()
        this.$emit('merge-updated')
      }

      this.uploadLoading = false
      this.$emit('busy-change', false)
      this.clearUploadRef()
      const ok = this.uploadItems.filter(f => f.status === 'success').length
      const fail = this.uploadItems.filter(f => f.status === 'fail').length
      if (ok > 0 && fail === 0) {
        this.$message.success(`全部上传成功（${ok} 张）`)
      } else if (ok > 0) {
        this.$message.warning(`成功 ${ok} 张，失败 ${fail} 张`)
      } else {
        this.$message.error('所有文件上传失败，请稍后重试')
      }
      setTimeout(() => { this.uploadItems = [] }, 1500)
    },
    clearUploadRef () {
      this.fileList = []
      clearTimeout(this.uploadTimer)
      if (this.$refs.uploadRef) this.$refs.uploadRef.clearFiles()
    },
    // 大图预览
    handlePreviewImage (url) {
      this.previewImageUrl = url
      this.previewVisible = true
    },
    // 删除待上传图片
    handleRemoveUploadItem (idx) {
      URL.revokeObjectURL(this.uploadItems[idx].url)
      this.uploadItems.splice(idx, 1)
      // 如果删完没有待上传的了，取消定时器
      if (!this.uploadItems.some(f => f.status === 'pending')) {
        clearTimeout(this.uploadTimer)
      }
    },
    handleFileExceed () {
      this.$message.warning('最多支持一次上传 10 张签到表图片')
    },

    // 签到表整合
    async handleMergeSign () {
      if (!this.rrmaId) {
        this.$message.warning('未获取到当前申请记录')
        return
      }
      this.mergeLoading = true
      this.$emit('busy-change', true)
      try {
        await updateRtReportModelUserSignMergeOnlySign({ rrmaId: this.rrmaId })
        this.$message.success('签到表整合成功')
        this.fetchMergeData()
        this.$emit('merge-updated')
      } catch (e) {
        this.$message.error(e.message || '签到表整合失败，请稍后重试')
      } finally {
        this.mergeLoading = false
        this.$emit('busy-change', false)
      }
    },

    // 导出签到表整合数据（使用模板导出）
    async handleMergeExport () {
      if (!this.mergeRecord || !this.mergeRecord.rrmusmId) {
        this.$message.warning('暂无可导出的整合数据')
        return
      }
      this.mergeExportLoading = true
      try {
        const result = await exportRtReportModelUserSignMergeSignExamUseModel({ rrmusmId: this.mergeRecord.rrmusmId })
        this.$message.success('导出成功：' + result.fileName)
      } catch (e) {
        this.$message.error(e.message || '导出失败，请稍后重试')
      } finally {
        this.mergeExportLoading = false
      }
    },

    // 查询整合数据（signAddExam）
    async fetchMergeData () {
      if (!this.rrmaId) return
      this.mergeTableLoading = true
      try {
        const res = await getRtReportModelUserSignMergeList({ rrmaId: this.rrmaId })
        let record = null
        if (Array.isArray(res.data)) {
          record = res.data.length ? res.data[res.data.length - 1] : null
        } else if (res.data && res.data.rrmusmId) {
          record = res.data
        }
        this.mergeRecord = record
        const parsed = this.parseSignAddExam(record && record.signAddExam)
        this.mergeTableColumns = parsed.columns
        this.mergeTableRows = parsed.rows
        this.mergeColumnConfigs = this.buildMergeColumnConfigs(parsed.columns)
      } catch (e) {
        this.mergeRecord = null
        this.mergeTableColumns = []
        this.mergeTableRows = []
        this.mergeColumnConfigs = []
      } finally {
        this.mergeTableLoading = false
      }
    },

    // 解析 signAddExam（兼容对象/字符串、修复数字 key 无引号）
    parseSignAddExam (val) {
      if (!val) return { columns: [], rows: [] }
      try {
        let data
        if (typeof val !== 'string') {
          data = val
        } else {
          const fixed = val.replace(/([{,]\s*)(\d+)\s*:/g, '$1"$2":')
          data = JSON.parse(fixed)
        }
        if (data.headerMap && data.rowMapList) {
          const indices = data.headerMap
            .map((h, i) => (h[0] && String(h[0]).trim()) ? i : -1)
            .filter(i => i >= 0)
          if (!indices.length) return { columns: [], rows: [] }
          const columns = indices.map(i => data.headerMap[i][0] || '')
          const rows = data.rowMapList.map(row => {
            const obj = {}
            indices.forEach((colIdx, i) => { obj['col_' + i] = row[colIdx] || '' })
            return obj
          }).filter(r => Object.values(r).some(v => v !== ''))
          return { columns, rows }
        }
        if (data.headList && data.dataList) {
          const headerObj = (data.headList[0] || {})
          const colKeys = Object.keys(headerObj).sort((a, b) => Number(a) - Number(b))
          const columns = colKeys.map(k => headerObj[k] || '').filter(h => h)
          const colIndices = colKeys.filter(k => headerObj[k] && String(headerObj[k]).trim())
          const rows = data.dataList.map(row => {
            const obj = {}
            colIndices.forEach((colIdx, i) => { obj['col_' + i] = row[colIdx] || '' })
            return obj
          }).filter(r => Object.values(r).some(v => v !== ''))
          return { columns, rows }
        }
        return { columns: [], rows: [] }
      } catch {
        return { columns: [], rows: [] }
      }
    },

    buildMergeColumnConfigs (columns) {
      return columns.map((col, i) => {
        const nc = String(col || '').replace(/\s/g, '').toLowerCase()
        const config = { prop: 'col_' + i, label: col, minWidth: 140 }
        if (/^(序号|序列|编号|id|no\.?|序)$/.test(nc)) config.width = 80
        else if (/(姓名|名字|name)/.test(nc)) config.minWidth = 100
        else if (/(员工编号|工号|学号|账号)/.test(nc)) config.minWidth = 140
        else if (/(单位|机构|部门|医院|学校|公司|门店|网点)/.test(nc)) config.minWidth = 160
        else if (/(签到|签退)/.test(nc)) config.minWidth = 100
        else if (/(备注|说明)/.test(nc)) config.minWidth = 120
        return config
      })
    },

    // 查看识别结果
    async handleViewDetail (row) {
      try {
        const res = await getRtReportModelUserSignOcrDetails({ rrmusoId: row.rrmusoId })
        this.detailData = res.data || row
        this.initEditableHeaders()
        this.detailVisible = true
      } catch (e) {
        this.$message.error('获取识别结果失败')
      }
    },

    // 导出 Excel
    async handleExport () {
      if (!this.detailData || !this.detailData.rrmusoId) {
        this.$message.warning('未获取到识别记录信息')
        return
      }
      this.exportLoading = true
      try {
        const result = await exportRtReportModelUserSignOcr({ rrmusoId: this.detailData.rrmusoId })
        this.$message.success('导出成功：' + result.fileName)
      } catch (e) {
        this.$message.error(e.message || '导出失败，请稍后重试')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// ===== 上传卡片 =====
.gen-sign-upload-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.gen-sign-upload-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: #f5f7fa;
  border-bottom: 1px solid #e8ecf1;
  white-space: nowrap;
}

.gen-sign-upload-title {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #9a3412;
  flex-shrink: 0;
  padding: 4px 12px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 5px;

  i { color: #f97316; font-size: 14px; flex-shrink: 0; }
}

.gen-sign-tip {
  font-size: 10px;
  color: #94a3b8;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gen-sign-upload-body {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;

  // 缩小拖拽区域，用 flex 替代 line-height 居中避免文字溢出
  ::v-deep .el-upload-dragger {
    width: 100%;
    height: 130px;
    line-height: normal;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 6px;

    .el-icon-upload {
      margin: 0;
      font-size: 36px;
      line-height: 36px;
      color: #c0c4cc;
    }

    .el-upload__text {
      font-size: 12px;
      margin-top: 6px;
      color: #606266;
      text-align: center;
      line-height: 1.5;
      padding: 0 16px;

      em { color: #409eff; }
    }
  }
}

.gen-sign-upload {
  ::v-deep .el-upload-list { display: none; }
}

.gen-sign-upload-warn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #f59e0b;
  font-weight: 500;

  i { font-size: 14px; }
}

.gen-sign-upload-status-card {
  margin: 0 16px 14px;
  padding: 12px 14px;
  border: 1px solid rgba(59, 130, 246, 0.18);
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(239, 246, 255, 0.94), rgba(255, 255, 255, 0.98));
}

.gen-sign-upload-status-card__main {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  color: #1e40af;
  font-size: 14px;
  font-weight: 850;
}

.gen-sign-upload-progress {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;

  i { font-size: 14px; }
}

.gen-sign-upload-progress-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  padding: 1px 8px;
  background: #dbeafe;
  color: #1e40af;
  border-radius: 10px;
  font-size: 11px;
}

.gen-sign-upload-status-card__sub {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
}

// 上传进度胶囊标签（上传中 / 等待上传 / 重试中）
.gen-sign-upload-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  margin-right: 6px;

  &--uploading {
    background: #dbeafe;
    color: #2563eb;
  }

  &--pending {
    background: #f1f5f9;
    color: #64748b;
  }

  &--retrying {
    background: #fef3c7;
    color: #d97706;
  }
}

.is-compact-upload {
  height: 100%;

  .gen-sign-upload-card,
  .gen-sign-records-card {
    border-radius: 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.06);
  }

  .gen-sign-upload-header,
  .gen-sign-records-header {
    background: linear-gradient(135deg, #eff6ff, #ffffff);
  }

  .gen-sign-upload-body {
    padding: 14px 16px;

    ::v-deep .el-upload-dragger {
      height: 150px;
      border-color: rgba(59, 130, 246, 0.38);
      background: linear-gradient(180deg, #ffffff, #f8fbff);

      .el-icon-upload { color: #2563eb; }
      .el-upload__text em { color: #2563eb; }
    }
  }
}

.is-records-only {
  margin-top: 18px;
}

.is-records-only .gen-sign-records-card {
  margin-top: 0;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(37, 99, 235, 0.06);
}

.is-records-only .gen-sign-records-header {
  background: linear-gradient(135deg, #eff6ff, #ffffff);
}

.gen-sign-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 12px;
  padding: 0 18px 16px;
}

.gen-sign-preview-item {
  text-align: center;
}

.gen-sign-preview-thumb {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #f5f7fa;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s;
  }

  &:hover img {
    transform: scale(1.05);
  }
}

.gen-sign-preview-del {
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 18px;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
  transition: background 0.15s;

  &:hover {
    background: rgba(239, 68, 68, 0.85);
  }
}

.gen-sign-preview-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);

  i {
    font-size: 22px;
    color: #4f7cff;
    animation: rotating 1.5s linear infinite;
  }

  // 重试中：橙色遮罩，与普通上传中的蓝色区分
  &--retry {
    background: rgba(254, 243, 199, 0.7);

    i {
      color: #f59e0b;
    }
  }
}

.gen-sign-preview-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  i { font-size: 12px; color: #fff; }

  &--success { background: #10b981; }
  &--fail { background: #ef4444; }
}

.gen-sign-preview-name {
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gen-sign-preview-status {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 500;
}

.preview-status--pending { color: #94a3b8; }
.preview-status--uploading { color: #4f7cff; }
.preview-status--retrying { color: #d97706; }
.preview-status--success { color: #10b981; }
.preview-status--fail { color: #ef4444; }

@keyframes rotating { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

.gen-sign-records-card {
  margin-top: 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.gen-sign-records-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  background: #f5f7fa;
  border-bottom: 1px solid #e8ecf1;
}

.gen-sign-records-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #9a3412;
  padding: 4px 12px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 5px;

  i { color: #f97316; font-size: 17px; }
}

.gen-sign-records-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: #4f7cff;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 10px;
}

.gen-sign-records-body {
  min-height: 80px;
}

// 空状态
.gen-sign-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 44px 24px 36px;
}

.gen-sign-empty-icon {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: linear-gradient(135deg, #eef2ff, #dfe7ff);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  i { font-size: 28px; color: #6366f1; }
}

.gen-sign-empty-text {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
}

.gen-sign-empty-hint {
  font-size: 12px;
  color: #94a3b8;
}

// 记录列表项
.gen-sign-record-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 18px;
  cursor: pointer;
  transition: background 0.15s;
  border-bottom: 1px solid #f1f5f9;

  &:last-child { border-bottom: none; }
  &:hover { background: #f8faff; }
}

.gen-sign-record-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: linear-gradient(135deg, #eef2ff, #dbeafe);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i { font-size: 17px; color: #4f7cff; }
}

.gen-sign-record-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.gen-sign-record-name {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.gen-sign-record-meta {
  font-size: 12px;
  color: #64748b;
}

// 识别状态标签
.gen-sign-record-status {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  vertical-align: middle;

  &.is-success {
    background: #ecfdf5;
    color: #059669;
  }

  &.is-fail {
    background: #fef2f2;
    color: #dc2626;
  }
}

.gen-sign-record-del {
  flex-shrink: 0;
  font-size: 15px !important;
  color: #94a3b8 !important;
  padding: 4px !important;

  &:hover {
    color: #ef4444 !important;
  }
}

.gen-sign-record-action {
  flex-shrink: 0;
  font-size: 13px !important;

  i { margin-left: 2px; }
}

// ===== 识别结果弹窗样式 =====
.sign-detail-content {
  overflow-x: hidden;
}

.sign-detail-meta {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 18px;
}

.sign-detail-meta-row {
  display: grid;
  grid-template-columns: 100px 1fr 100px 1fr;
  border-bottom: 1px solid #e2e8f0;

  &:last-child { border-bottom: none; }
}

.sign-detail-meta-cell {
  padding: 10px 14px;
  font-size: 13px;

  &--label {
    background: #f5f7fa;
    color: #606266;
    font-weight: 500;
  }

  &--value {
    color: #1e293b;
  }
}

.sign-detail-section {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 18px 0 10px;
  padding-left: 10px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 16px;
    background: linear-gradient(180deg, #4f7cff, #6366f1);
    border-radius: 2px;
  }

  i { font-size: 16px; color: #4f7cff; margin-left: 4px; }
}

.sign-detail-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.sign-detail-table-wrap {
  margin-bottom: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.sign-detail-empty {
  padding: 24px 16px;
  border: 1px dashed #dbe3ef;
  border-radius: 8px;
  margin-bottom: 18px;
}

.sign-detail-raw-text {
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  max-height: 240px;
  overflow: auto;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  white-space: pre-wrap;
  color: #475569;
  word-break: break-all;
}

// ===== 签到表整合数据卡片 =====
.gen-sign-merge-card {
  margin-top: 14px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.gen-sign-merge-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  background: #f5f7fa;
  border-bottom: 1px solid #e8ecf1;
}

.gen-sign-merge-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #9a3412;
  padding: 4px 12px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 5px;

  i { color: #f97316; font-size: 17px; }
}

.gen-sign-merge-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: #6366f1;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 10px;
}

.gen-sign-merge-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.gen-sign-merge-meta {
  font-size: 12px;
  color: #64748b;
}

.gen-sign-merge-body {
  min-height: 80px;
  overflow-x: auto;
}

.gen-sign-merge-table-wrap {
  overflow-x: auto;
}

::v-deep .sign-merge-cell-center {
  .cell {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// 单元格编辑模式
::v-deep .is-cell-editing {
  .el-table__header th {
    padding: 4px 0;
  }

  .sign-header-input {
    .el-input__inner {
      height: 28px;
      line-height: 28px;
      text-align: center;
      font-weight: 600;
      border-color: #c6e2ff;
      background: #f0f7ff;
    }
  }
}

.sign-cell-text {
  min-height: 28px;
  line-height: 28px;
  padding: 2px 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s;

  &:hover {
    background: #f0f7ff;
  }
}

// 表头编辑态：点击变为输入框
.sign-header-text {
  min-height: 26px;
  line-height: 26px;
  padding: 0 4px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s;

  &:hover {
    background: rgba(239, 246, 255, 0.7);
  }
}

.sign-header-editing {
  padding: 0;

  .sign-cell-input {
    .el-input__inner {
      height: 26px;
      line-height: 26px;
      padding: 0 6px;
      text-align: center;
    }
  }
}

.sign-cell-editing {
  padding: 0;

  .sign-cell-input {
    .el-input__inner {
      height: 28px;
      line-height: 28px;
      padding: 0 8px;
    }
  }
}

// 大图预览弹框
::v-deep .preview-image-dialog {
  border-radius: 10px;
  overflow: hidden;

  .el-dialog__header {
    padding: 14px 20px;
    border-bottom: 1px solid #eef1f6;
  }

  .el-dialog__body {
    padding: 16px;
  }
}
</style>
